export const setLocalStorageValue = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getLocalStorageValue = (key) => {
  const value = localStorage.getItem(key);

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

export const removeLocalStorageEntry = (key) => {
  localStorage.removeItem(key);
};
